import { Skeleton } from 'antd';
import { memo } from 'react';

import { StyledLoadingSkeletonWrapper } from './DynamicSizeSkeleton.styles';

export type DynamicSizeSkeletonProps = {
  width?: number;
  height?: number;
};

export const DynamicSizeSkeleton = memo(
  ({ height, width }: DynamicSizeSkeletonProps) => {
    return (
      <StyledLoadingSkeletonWrapper
        style={{
          ...(width &&
            height && {
              width: `${width}px`,
              height: `${height}px`,
            }),
        }}
      >
        <Skeleton.Node active />
      </StyledLoadingSkeletonWrapper>
    );
  },
  (prev, next) => {
    return prev.width === next.width && prev.height === next.height;
  }
);
